module.exports = __webpack_public_path__ + "assets/img/57.fea175ba.png";